import { useRefetchQuery } from "libs/reactQuery";
import { toast } from "react-hot-toast";
import { Modal } from "ui";

import { useCreateAnnouncement, useUpdateAnnouncement } from "../../../apis";
import {
  convertAnnouncementFormDataToCreateRequestBody,
  getInitialAnnouncementFormValues
} from "../../../helpers";
import { AnnouncementFormValues } from "../../forms";
import { AnnouncementForm } from "../../forms/AnnouncementForm";
import { AnnouncementModalProps } from "./AnnouncementModal.types";

const ANNOUNCEMENT_FORM_ID = "announcement-form-id";

const AnnouncementModal = ({
  isOpen,
  onClose,
  editableAnnouncement
}: AnnouncementModalProps) => {
  const refetchAnnouncements = useRefetchQuery(["announcements"]);

  const createAnnouncement = useCreateAnnouncement({
    onSuccess: () => {
      onClose();
      refetchAnnouncements();
      toast.success("Announcement created successfully");
    }
  });

  const updateAnnouncement = useUpdateAnnouncement({
    onSuccess: () => {
      onClose();
      refetchAnnouncements();
      toast.success("Announcement updated successfully");
    }
  });

  const handleFormSubmit = (formData: AnnouncementFormValues) => {
    if (editableAnnouncement) {
      updateAnnouncement.mutate({
        id: editableAnnouncement.id,
        ...convertAnnouncementFormDataToCreateRequestBody(formData)
      });
    } else {
      createAnnouncement.mutate(
        convertAnnouncementFormDataToCreateRequestBody(formData)
      );
    }
  };

  return (
    <Modal
      formId={ANNOUNCEMENT_FORM_ID}
      isOpen={isOpen}
      title={editableAnnouncement ? "Change Announcement" : "New Announcement"}
      isLoading={createAnnouncement.isLoading || updateAnnouncement.isLoading}
      okText={editableAnnouncement ? "Save" : "Create"}
      onClose={onClose}
    >
      <AnnouncementForm
        formId={ANNOUNCEMENT_FORM_ID}
        onSubmit={handleFormSubmit}
        isEdit={!!editableAnnouncement}
        defaultValues={getInitialAnnouncementFormValues(editableAnnouncement)}
      />
    </Modal>
  );
};

export default AnnouncementModal;
